export default __webpack_public_path__ + "static/media/angoloGrigio.4c7d99c3.avif";